import React from "react";
import { MEMBER_STATE_LABEL } from "../../_config/quarterlyOkrConfig";
import { PersonInline } from "../../_shared/QokrPrimitives/QokrPrimitives";
import "./_summary-not-submitted.scss";

// People who never submitted their OKRs and where each one stopped. The BE
// sends this list to the CEO and coach only.
const SummaryNotSubmitted = ({ people = [] }) =>
  people.length ? (
    <section className="qokr-summary-missing">
      <h2 className="qokr-summary-missing__title">Did not submit</h2>
      <ul className="qokr-summary-missing__list">
        {people.map((person) => (
          <li key={person.user_id} className="qokr-summary-missing__item">
            <PersonInline person={person} />
            <span className="qokr-pill qokr-pill--grey">
              {MEMBER_STATE_LABEL[person.member_state] || "Not submitted"}
            </span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;

export default SummaryNotSubmitted;
